import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export interface ApiEnvelope<T> {
  code: number
  data: T
  totalCount: number
  requestStatus: boolean
}

export interface LoginTokens {
  accessToken: string
  refreshToken: string
}

export interface FireFighterUserData {
  userName: string
  haulerName: string
  roleName: string
  accessToken: string
  userId: string
  email: string
  widgetCapabilitiy?: {
    widgetCapabilities: { widgetName: string; widgetCapabilityCode: string }[]
    capabilities: string[]
  }
}

export type EmergencyLoginResponse = ApiEnvelope<LoginTokens>
export type FireFighterAuthorizeResponse = ApiEnvelope<FireFighterUserData>
export type RenewTokensResponse = ApiEnvelope<LoginTokens>

export interface AuthorizedUserResponse {
  accessToken: string
  widgetCapabilitiy?: {
    capabilities: any
    widgetCapabilities: any[]
  }
  [key: string]: any
}

export const authApi = createApi({
  reducerPath: 'auth',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_AUTH_BASE_URL + 'auth',
  }),
  tagTypes: ['auth'],
  endpoints: (builder) => ({
    getAuthorize: builder.query<AuthorizedUserResponse, string>({
      query: (token: string) => {
        return {
          url: '/Authorize',
          headers: { Authorization: `Bearer ${token}` },
        }
      },
      providesTags: ['auth'],
    }),
    getFireFighterAuthorize: builder.query<
      FireFighterAuthorizeResponse,
      string
    >({
      query: (token: string) => {
        return {
          url: '/FireFighterAuthorize',
          headers: { Authorization: `Bearer ${token}` },
        }
      },
      providesTags: ['auth'],
    }),
    getFireFighterAccessConfig: builder.query<
      { isFireFighterAccessEnabled: boolean },
      void
    >({
      query: () => ({ url: '/GetFireFighterAccessConfig' }),
    }),
    emergencyLogin: builder.mutation<
      EmergencyLoginResponse,
      { userEmail: string; password: string; clientId: string }
    >({
      query: (credentials) => ({
        url: '/Login',
        method: 'POST',
        body: credentials,
      }),
    }),
    renewTokens: builder.mutation<RenewTokensResponse, string>({
      query: (refreshToken: string) => ({
        url: '/RenewTokens',
        method: 'POST',
        body: { refreshToken },
      }),
    }),
  }),
})

export const {
  useLazyGetAuthorizeQuery,
  useLazyGetFireFighterAuthorizeQuery,
  useLazyGetFireFighterAccessConfigQuery,
  useEmergencyLoginMutation,
  useRenewTokensMutation,
} = authApi
